<script setup lang="ts">
// Runbooks are called "Actions" in the app now; keep old links working.
definePage({
  redirect: (to) => ({ path: "/actions", query: to.query }),
});
</script>

<template>
  <div />
</template>
